const footerHoltUnderGrad = {
  logo: {
    alt: "Rollins College",
    image: `https://cdn.sanity.io/images/qe2ul2l0/production/697b1ea697b8ddf0eb0394fb0c6d6aaa889129cf-268x135.svg`,
  },
  contactInfo: {
    title: "Office of Admission",
    street: "1000 Holt Ave - 2725",
    city: "Winter Park",
    state: "FL",
    zip: "32789",
    phone: "(407) 646-2037",
    email: "holtadmission@rollins.edu",
  },
  socialLinks: [
    {
      type: "Facebook",
      url: "https://www.facebook.com/rollinsprofessionaladvancement",
    },
    {
      type: "Instagram",
      url: "https://www.instagram.com/rollinsprofessionaladvancement/",
    },
    {
      type: "LinkedIn",
      url: "https://www.linkedin.com/company/rollinsprofessionaladvancement",
    },
  ],
  mainLinks: [
    {
      label: "Why Rollins",
      url: "/professional-advancement/why-rollins",
    },
    {
      label: "Degree Programs",
      url: "/professional-advancement/degree-programs",
    },
    {
      label: "Apply",
      url: "/professional-advancement/apply",
    },
    {
      label: "Visit",
      url: "/professional-advancement/visit",
    },
    {
      label: "Tuition & Aid",
      url: "/professional-advancement/tuition-aid",
    },
    {
      label: "News",
      url: "/professional-advancement/news",
    },
    {
      label: "About",
      url: "/professional-advancement/about",
    },
  ],
  miscLinks: [
    {
      label: "Information About",
      items: [
        {
          label: "Full-Time Undergraduate",
          url: "/college-of-liberal-arts",
        },
        {
          label: "Transferring to Rollins",
          url: "/transfer-to-rollins-college/",
        },
        {
          label: "Graduate Business & Executive Education",
          url: "https://crummer.rollins.edu",
        },
        {
          label: "Professional Advancement",
          url: "/professional-advancement/",
        },
        {
          label: "Graduate Studies",
          url: "/graduate/",
        },
      ],
    },
  ],
  ctas: [
    {
      label: "Request Information",
      url: "https://holt.rollins.edu/register/pa-request-info",
    },
    {
      label: "Take a Virtual Tour",
      url: "https://youvis.it/TGkZv4",
    },
    {
      label: "Schedule A Tour",
      url: "/professional-advancement/visit",
    },
    {
      label: "Start an Application",
      url: "/professional-advancement/apply",
    },
  ],
  copyright: {
    year: "© 2022",
    website: {
      label: "Rollins College",
      url: "https://www.rollins.edu/",
    },
    links: [
      {
        label: "Privacy Policy",
        target: "_blank",
        url: "https://www.rollins.edu/the-fine-print/privacy-policy",
      },
    ],
  },
};

export default footerHoltUnderGrad;
